import * as rootReducers from '../store.reducers';
import { Auth, EMPTY_AUTH } from "src/app/auth/models/auth";
import { ApplySessionPayload, BaseAction, SessionActionType } from "../store.actions";
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';


export interface State extends rootReducers.State {
  auth: Auth;
}


const initialState: Auth = EMPTY_AUTH;

export function authReducer(state: Auth = initialState, action: BaseAction): Auth {
  switch (action.type) {
    case SessionActionType.APPLY_SESSION: {
      // Atomic session apply: the identity half of the shared action (the enrollment half is handled
      // by the twoFactor reducer, so both slices update in one emission). This is now the SOLE writer
      // of the auth slice — the legacy piecemeal AuthActionType.FULL/isAuthenticated/Roles actions were
      // removed with the 2FA session refactor, so no path can write the identity without the enrollment
      // flag and re-introduce the single-writer footgun. See SessionActionType.
      return (action.payload as ApplySessionPayload)?.auth || initialState as Auth;
    }
    default:
      return state;
  }

}


export const FEATURE_NAME = 'auth';
export const selectAuth = createFeatureSelector<Auth>(
  FEATURE_NAME
);

export const selectIsAutenticated: MemoizedSelector<State, boolean> = createSelector(selectAuth, (state: Auth) => state.isAuthenticated);
export const selectAuthRoles: MemoizedSelector<State, string[]> = createSelector(selectAuth, (state: Auth) => state.roles);
